var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action } from "../../../ExternalDependencies";
export var ChangePasswordFromState;
(function (ChangePasswordFromState) {
    ChangePasswordFromState[ChangePasswordFromState["loading"] = 0] = "loading";
    ChangePasswordFromState[ChangePasswordFromState["notValidToken"] = 1] = "notValidToken";
    ChangePasswordFromState[ChangePasswordFromState["loaded"] = 2] = "loaded";
    ChangePasswordFromState[ChangePasswordFromState["success"] = 3] = "success";
    ChangePasswordFromState[ChangePasswordFromState["closed"] = 4] = "closed";
})(ChangePasswordFromState || (ChangePasswordFromState = {}));
export class ChangePasswordState {
    constructor(props) {
        this.newPass = "";
        this.confirmPass = "";
        this.formState = ChangePasswordFromState.loading;
        this.dict = props.dict;
        this.config = props.cms;
        this.newPassValidator = props.newPassValidator;
        this.confPassValidator = props.confPassValidator;
        this.diffPassValidator = props.diffPassValidator;
        this.playerDataConnection = props.playerDataConnection;
        this.serverError = { message: "", visible: false };
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clear();
            yield this.tokenValidationRequest();
        });
    }
    deactivate() {
        this.clear();
        this.setFormState(ChangePasswordFromState.closed);
    }
    clear() {
        this.newPass = "";
        this.confirmPass = "";
        this.newPassError = undefined;
        this.confPassError = undefined;
        this.diffPassError = undefined;
        this.serverError = { message: "", visible: false };
    }
    handleNewPassChange(event) {
        this.newPass = event.target.value;
        this.newPassError = undefined;
        this.diffPassError = undefined;
    }
    validateNewPass() {
        this.newPassError = this.newPassValidator.validate(this.newPass);
        if (this.newPassError === undefined && this.confirmPass !== "") {
            this.diffPassError = this.diffPassValidator.validate([this.newPass, this.confirmPass]);
        }
    }
    handleConfPassChange(event) {
        this.confirmPass = event.target.value;
        this.confPassError = undefined;
        this.diffPassError = undefined;
    }
    validateConfPass() {
        this.confPassError = this.confPassValidator.validate(this.confirmPass);
        if (this.confPassError === undefined) {
            this.diffPassError = this.diffPassValidator.validate([this.newPass, this.confirmPass]);
        }
    }
    handleSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isValid()) {
                yield this.changePassRequest();
            }
        });
    }
    isValid() {
        this.validateNewPass();
        this.validateConfPass();
        return !(this.newPassError || this.confPassError || this.diffPassError);
    }
    changePassRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const request = {
                    prt: this.config.prt,
                    newPwd: this.newPass
                };
                yield this.playerDataConnection.changePassword(request);
                this.setFormState(ChangePasswordFromState.success);
                this.config.onSuccessCallback();
            }
            catch (error) {
                console.warn(error.message);
                this.handleError(error);
            }
        });
    }
    tokenValidationRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const request = {
                    type: "TokenCheck",
                    body: {
                        type: "changepwd",
                        token: this.config.prt
                    }
                };
                const result = yield this.playerDataConnection.verifyToken(request);
                this.setFormState(result.body.valid ? ChangePasswordFromState.loaded : ChangePasswordFromState.notValidToken);
            }
            catch (error) {
                this.setFormState(ChangePasswordFromState.notValidToken);
            }
        });
    }
    setFormState(value) {
        this.formState = value;
    }
    handleError(error) {
        var _a, _b, _c, _d;
        const errorCode = error.data && ((_b = (_a = error.data[0]) === null || _a === void 0 ? void 0 : _a.errors[0]) === null || _b === void 0 ? void 0 : _b.code) || error.code;
        const msg = error.data && ((_d = (_c = error.data[0]) === null || _c === void 0 ? void 0 : _c.errors[0]) === null || _d === void 0 ? void 0 : _d.msg) || error.msg;
        let errorMessage = this.getServerErrorMessage(errorCode, msg);
        this.setServerError(errorMessage);
    }
    getServerErrorMessage(errorCode, msg) {
        return this.getErrorFromCode(errorCode) || this.getErrorFromMessage(msg);
    }
    getErrorFromCode(errorCode) {
        if (errorCode === "5031") {
            return this.dict["password-was-previously-in-use"];
        }
        else if (errorCode === "5016") {
            return this.dict.PlayerApiNotSupported;
        }
        return undefined;
    }
    getErrorFromMessage(msg) {
        if (msg && msg === "Validation Failed") {
            return this.dict.PasswordResetPasswordError;
        }
        else if (msg) {
            return this.dict[msg] || msg;
        }
        else {
            return this.dict.ServerError;
        }
    }
    setServerError(message) {
        this.serverError = { message, visible: true };
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], ChangePasswordState.prototype, "newPass", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], ChangePasswordState.prototype, "confirmPass", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChangePasswordState.prototype, "serverError", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChangePasswordState.prototype, "newPassError", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChangePasswordState.prototype, "confPassError", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ChangePasswordState.prototype, "diffPassError", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], ChangePasswordState.prototype, "formState", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "clear", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "handleNewPassChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "validateNewPass", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "handleConfPassChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "validateConfPass", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ChangePasswordState.prototype, "handleSubmit", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "setFormState", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "handleError", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ChangePasswordState.prototype, "setServerError", null);
//# sourceMappingURL=ChangePasswordState.js.map